import { Rda } from './rda.model';
import { Moment } from 'moment';

export class ProcessoCartaCreditoFinanceiro{

  id: number;
  rda: Rda;
  declarou: boolean;
  caminhoArquivoDeclaracao: string;
  nrProcessoSei: string;
  dataCriacao: Moment;
}
